// test1259
(1259 && 0);
